import { render, staticRenderFns } from "./TokenDetail.vue?vue&type=template&id=2f1ac69f&scoped=true&"
import script from "./TokenDetail.vue?vue&type=script&lang=js&"
export * from "./TokenDetail.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetail.vue?vue&type=style&index=0&id=2f1ac69f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ac69f",
  null
  
)

export default component.exports